// extracted by mini-css-extract-plugin
export var clearButton = "input-search-module--clear-button--+uQ0x";
export var clearIcon = "input-search-module--clear-icon--24IRM";
export var input = "input-search-module--input--T4bvh";
export var large = "input-search-module--large--GNClE";
export var searchIcon = "input-search-module--search-icon--9JOxj";
export var small = "input-search-module--small--lEcg-";
export var wrapper = "input-search-module--wrapper--6rUpa";